import request from '@/utils/request'

let Job_typeApi = {

  /*岗位类型列表*/
  list(data) {
    return request._post('/shop/plus.job_type.Index/index', data);
},
/*添加岗位类型*/
add(data) {
    return request._post('/shop/plus.job_type.Index/add', data);
},
/*修改岗位类型*/
edit(data) {
    return request._post('/shop/plus.job_type.Index/edit', data);
},
/*删除岗位类型*/
del(data) {
    return request._post('/shop/plus.job_type.Index/del', data);
},
/*岗位类型详情*/
detail(data) {
  return request._post('/shop/plus.job_type.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.job_type.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.job_type.Setting/getSetting', data, errorback);
    },
}
export default Job_typeApi;



// WEBPACK FOOTER //
// ./src/api/job_type.js